import React from "react";
import { Link } from "react-router-dom";
import Seo from "../seo/Seo";
import { seoConfig } from "../seo/seoConfig";

const NoPage = () => {
  return (
    <div className="container my-5 text-center">
      <Seo {...seoConfig.notFound} />
      <h1>404 — Página não encontrada</h1>
      <p>A página que procura não existe ou foi movida.</p>
      <Link to="/" className="fw-bold">
        Voltar à página inicial
      </Link>
    </div>
  );
};

export default NoPage;
